import fixtures from './fixtures.json';

// Domain
import {
  LevelOfEducationRepository,
} from '../../../domain/repositories/level-of-education-repository';
import {
  LevelOfEducationEntity,
} from '../../../domain/entities/level-of-education-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class LevelOfEducationDummyRepository implements LevelOfEducationRepository {
  get(): Promise<Array<LevelOfEducationEntity>> {
    return Promise.resolve(fixtures);
  }
}
